import { render, staticRenderFns } from "./feed-setup.vue?vue&type=template&id=7f80e06a&scoped=true&"
import script from "./feed-setup.vue?vue&type=script&lang=js&"
export * from "./feed-setup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f80e06a",
  null
  
)

export default component.exports